module.exports = __webpack_public_path__ + "static/media/twtter.30d52a9f.png";